import * as React from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/app/components/ui/button";

/** Page-header — title + sub + back + optional per-page actions. LangSwitch đã lên AppHeader. */
export function Topbar({
  title,
  sub,
  showBack,
  onBack,
  actions,
}: {
  title: React.ReactNode;
  sub?: string;
  showBack?: boolean;
  onBack?: () => void;
  actions?: React.ReactNode;
}) {
  return (
    <div className="sticky top-0 z-10 flex items-center gap-3 border-b border-border bg-white/80 px-4 py-3 backdrop-blur">
      {showBack && (
        <Button variant="ghost" size="icon" onClick={onBack} aria-label="back">
          <ChevronLeft className="h-4 w-4" />
        </Button>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="text-base font-semibold leading-tight truncate">{title}</h1>
        {sub && (
          <p
            className="text-xs text-muted-foreground leading-snug"
            dangerouslySetInnerHTML={{ __html: sub }}
          />
        )}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
